import apiClient from '@/utils/apiClient'

let base_errors = {}
export default {
  //region fetch
  async fetchAllCustomer({ commit }) {
    await apiClient
      .get('api/customer')
      .then((response) => {
        commit('setCustomerList', response.data.customers)
        commit('setCustomerMetadata', response.data.metadata)
      })
      // Already toasted by apiClient.
      .catch(() => {})
  },

  async fetchCustomerByID({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/customer/${payload.id}`)
      .then(async (response) => {
        await commit('setCustomer', response.data.customer)
        await commit('setCustomerMetadata', response.data.metadata)
      })
      // Already toasted by apiClient.
      .catch(() => {})
  },
  async fetchNewCustomer({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/model/new?model=customer')
      .then((response) => {
        commit('setCustomer', response.data.customer)
        commit('setCustomerMetadata', response.data.metadata)
      })
      // Already toasted by apiClient.
      .catch(() => {})
  },
  async fetchCustomerActivitiesByCustomerID({ commit }, payload) {
    await apiClient
      .get(`api/customer/fetch-activities/${payload.customer_id}`)
      .then(async (response) => {
        await commit('setCustomerActivity', response.data.activities)
      })
      .catch(async (reason) => {
        await console.error('fetchCustomerActivitiesByCustomerID', reason)
      })
  },
  //endregion

  //region store
  storeNewCustomer(_, payload) {
    console.log(payload)
    return apiClient.post('api/customer', payload.customer).then((response) => {
      return response.data
    })
  },
  storeNewCustomerUser({ dispatch }, payload) {
    return apiClient.post('api/user', payload.user).then((response) => {
      dispatch('fetchCustomerByID', { id: response.data.user.customer_id })
      return response.data
    })
  },
  //endregion

  //region update
  updateCustomer(_, payload) {
    console.log(payload)
    return apiClient
      .put(`api/customer/${payload.id}`, payload.customer)
      .then((response) => {
        return response.data
      })
  },

  updateCustomerUser({ commit, dispatch }, payload) {
    return apiClient
      .put(`api/user/${payload.id}`, payload.user)
      .then((response) => {
        dispatch('fetchCustomerByID', { id: response.data.user.customer_id })
        return response.data
      })
  },
  //endregion

  //region delete
  deleteCustomerById({ commit }, payload) {
    return apiClient
      .delete(`api/customer/${payload.id}`)
      .then(async (response) => {
        commit('setCustomerList', response.data.customers)
        commit('setCustomerMetadata', response.data.metadata)
        return response.data
      })
  },
  //endregion

  //region undoDelete
  undoDeleteCustomerById({ commit }, payload) {
    return apiClient
      .get(`api/customer/undo-delete/${payload.id}`)
      .then(async (response) => {
        commit('setCustomerList', response.data.customers)
        commit('setCustomerMetadata', response.data.metadata)
        return response.data
      })
  }
  //endregion
}
